///<reference path="../../employee/sections/employee.compensation.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class CompensationSection extends Meevo.Plugins.Employee.CompensationSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherCompensations;
        }
    }
}